<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  clearable
                  multiple
                  v-bind:collapse-tags="true"
                  @change="
                    selectAllFromSelect(
                      'elaborateBoxesReportsForm.farm_id',
                      farms
                    );
                    showCalendar();
                  "
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="elaborateBoxesReportsForm.farm_id"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                v-if="isShowCalendar"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-calendar shadow-sm"
                  size="large"
                  v-model="elaborateBoxesReportsForm.calendar_sel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in calendars"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  clearable
                  @change="changeByInterval"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="elaborateBoxesReportsForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  elaborateBoxesReportsForm.bySel != 'week' &&
                  elaborateBoxesReportsForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  elaborateBoxesReportsForm.bySel == 'week' ||
                  elaborateBoxesReportsForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="elaborateBoxesReportsForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="elaborateBoxesReportsForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  elaborateBoxesReportsForm.bySel == 'week' &&
                  elaborateBoxesReportsForm.year_sel_init
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="elaborateBoxesReportsForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[
                      elaborateBoxesReportsForm.year_sel_init
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  elaborateBoxesReportsForm.bySel == 'week' ||
                  elaborateBoxesReportsForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="elaborateBoxesReportsForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="elaborateBoxesReportsForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  elaborateBoxesReportsForm.bySel == 'week' &&
                  elaborateBoxesReportsForm.year_sel_end
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="elaborateBoxesReportsForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[
                      elaborateBoxesReportsForm.year_sel_end
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">
                  {{ $t('common_words.filter') }} </label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
            <br />
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="elaborateBoxesReport"
        :title="$t('production.crafted_boxes')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="custom-flex">
              <el-select
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="table-responsive">
              <table
                aria-describedby="tabla-cajas-elaboradas"
                class="table table-striped table-bordered"
              >
                <thead class="cusmtom-thead-color">
                  <tr>
                    <td
                      rowspan="2"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <span v-if="elaborateBoxesReportsForm.farm_id.length > 1"
                        ><strong>{{
                          $t('common_words.farm_mayus')
                        }}</strong></span
                      >
                      <span v-else
                        ><strong>{{
                          $t('production.boxes_mayus')
                        }}</strong></span
                      >
                    </td>
                    <td
                      colspan="2"
                      class="text-center"
                      style="font-size: smaller"
                      v-for="(column, c) in reports.report1.columns"
                      :key="c"
                    >
                      <strong>{{ c }}</strong>
                    </td>
                    <td
                      rowspan="2"
                      class="text-center"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{ $t('common_words.total_mayus') }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <template v-for="(column, c) in reports.report1.columns">
                      <td class="text-center">
                        {{ $t('production.crafted') }}
                      </td>
                      <td class="text-center">
                        {{ $t('production.rejected_2') }}
                      </td>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, box) in pagedRows" :key="box">
                    <td class="text-center white-space-nowrap">{{ row }}</td>
                    <template v-for="(cls, cl) in reports.report1.columns">
                      <td class="text-center white-space-nowrap">
                        {{ formatNumber(getDataByBox(cl, row).number_boxes) }}
                      </td>
                      <td class="text-center white-space-nowrap" :key="cl">
                        {{
                          formatNumber(
                            getDataByBox(cl, row).number_boxes_reject
                          )
                        }}
                      </td>
                    </template>
                    <td class="text-center white-space-nowrap">
                      <strong>{{
                        formatNumber(calculateTotalRow(row, reports.report1))
                      }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-muted text-center">
                      <strong>{{ $t('common_words.total_mayus') }}</strong>
                    </td>
                    <template v-for="(cls, cl) in reports.report1.columns">
                      <td class="text-center white-space-nowrap">
                        <strong>{{
                          formatNumber(
                            calculateTotalColumn(cl, reports.report1)
                          )
                        }}</strong>
                      </td>
                      <td class="text-center white-space-nowrap" :key="cl">
                        <strong>{{
                          formatNumber(
                            calculateTotalColumn(
                              cl,
                              reports.report1,
                              'number_boxes_reject'
                            )
                          )
                        }}</strong>
                      </td>
                    </template>
                    <td class="text-center" style="font-size: smaller">
                      <strong>{{
                        formatNumber(
                          calculateTotalColumn(null, reports.report1, 'total')
                        )
                      }}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div class="row" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF(1)"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel(1)"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import Formatter from 'src/class/Formatter';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import paginationTable from './pagination';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: {
    calendars() {
      if (this.elaborateBoxesReportsForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          this.elaborateBoxesReportsForm.farm_id.forEach((elFarm) => {
            if (element.id == elFarm) {
              calendars = element.calendars;
            }
          });
        });

        return calendars;
      } else {
        return [];
      }
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },

    ...paginationTable.functions,
  },

  data() {
    return {
      elaborateBoxesReportsForm: {
        farm_id: [],
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        bySel: null,
        year_sel: null,
        calendar_sel: null,
        user_id: this.$store.state.auth.user.id,
      },
      activeName: '1',
      pagination: paginationTable.pagination,
      typedatepicket: 'daterange',
      row: null,
      valueCollapse: null,
      reports: [],
      interval: 'Semana',
      years: [],
      farms: [],
      elaborateBoxesReport: false,
      isShowCalendar: false,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },
  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    getDataByBox(cl, row) {
      return { ...this.reports.report1.data[cl][row] };
    },

    showCalendar() {
      this.elaborateBoxesReportsForm.calendar_sel = null;
      this.isShowCalendar = true;
      this.elaborateBoxesReport = false;

      for (let index = 0; index < Object.values(this.farms).length; index++) {
        const element = Object.values(this.farms)[index];

        this.elaborateBoxesReportsForm.farm_id.forEach((elFarm) => {
          if (element.id != 0 && element.id == elFarm) {
            if (element.calendars.length > 1) {
              this.elaborateBoxesReportsForm.calendar_sel = null;
              this.isShowCalendar = true;
            } else {
              if (element.calendars.length == 1) {
                this.elaborateBoxesReportsForm.calendar_sel =
                  element.calendars[0].id;
                this.isShowCalendar = false;
              }
            }
          }
        });
      }

      this.isShowCalendar = false;
    },

    changeByInterval() {
      this.elaborateBoxesReport = false;
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.elaborateBoxesReportsForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    formatNumber(value) {
      return Formatter.formatNumber(value);
    },

    validate() {
      if (
        this.elaborateBoxesReportsForm.farm_id == null ||
        this.elaborateBoxesReportsForm.farm_id.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.elaborateBoxesReportsForm.bySel == 'year' &&
          (this.elaborateBoxesReportsForm.year_sel_init == null ||
            this.elaborateBoxesReportsForm.year_sel_end == null)) ||
        (this.elaborateBoxesReportsForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.elaborateBoxesReportsForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.elaborateBoxesReportsForm.week_sel_init == null &&
        this.elaborateBoxesReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('eek');
      } else if (
        this.isYearSelRequired() &&
        this.elaborateBoxesReportsForm.year_sel_end == null &&
        this.elaborateBoxesReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.elaborateBoxesReportsForm.week_sel_end == null &&
        this.elaborateBoxesReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.elaborateBoxesReportsForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.loadElaborateBoxesReport();
      }
    },

    calculateTotalRow(row, object) {
      let total = 0;
      Object.values(object.columns).forEach((element) => {
        Object.values(object.data[element.elaborate_box_week]).forEach(
          (item) => {
            total +=
              item.name == row
                ? parseInt(item.number_boxes ? item.number_boxes : 0) -
                  parseInt(
                    item.number_boxes_reject ? item.number_boxes_reject : 0
                  )
                : 0;
          }
        );
      });
      return total;
    },

    calculateTotalColumn(column, object, type = 'number_boxes') {
      let total = 0;
      if (type === 'total') {
        Object.values(object.data).forEach((element) => {
          Object.values(element).forEach((item) => {
            total +=
              parseInt(item.number_boxes ? item.number_boxes : 0) -
              parseInt(item.number_boxes_reject ? item.number_boxes_reject : 0);
          });
        });
      } else {
        if (type === 'number_boxes_reject') {
          Object.values(object.data[column]).forEach((item) => {
            total += parseInt(
              item.number_boxes_reject ? item.number_boxes_reject : 0
            );
          });
        } else {
          if (type === 'number_boxes') {
            Object.values(object.data[column]).forEach((item) => {
              total += parseInt(item.number_boxes ? item.number_boxes : 0);
            });
          }
        }
      }

      return total;
    },

    loadData() {
      let data = {
        farm: this.elaborateBoxesReportsForm.farm_id,
        init:
          parseInt(this.elaborateBoxesReportsForm.year_sel_init) * 100 +
          parseInt(this.elaborateBoxesReportsForm.week_sel_init),
        end:
          parseInt(this.elaborateBoxesReportsForm.year_sel_end) * 100 +
          parseInt(this.elaborateBoxesReportsForm.week_sel_end),
        bySel: this.elaborateBoxesReportsForm.bySel,
      };

      switch (this.elaborateBoxesReportsForm.bySel) {
        case 'year':
          data.init = parseInt(this.elaborateBoxesReportsForm.year_sel_init);
          data.end = parseInt(this.elaborateBoxesReportsForm.year_sel_end);
          break;
        case 'monthrange':
          data.init = parseInt(moment(this.rangeDate[0]).format('YYYYMM'));
          data.end = parseInt(moment(this.rangeDate[1]).format('YYYYMM'));
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    exportToPDF(option) {
      let data = this.loadData();
      data.route = 'boxes/reports/pdf';
      data.option = option;
      data.name_file = `${i18n.t('production.crafted_box_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel(option) {
      let data = this.loadData();
      data.route = 'boxes/reports/excel/';
      data.option = option;
      data.name_file = `${i18n.t('production.crafted_box_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    loadElaborateBoxesReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'boxes/reports';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            if (response.data.report1.data.length == 0) {
              SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            } else {
              this.reports = response.data;
              this.elaborateBoxesReport = true;

              /* this.pagination.perPage = 5;
              this.pagination.currentPage = 1;

              this.updateDataPagination(
                'cardfooter',
                [this.from, this.to, this.total],
                5
              ); */
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('boxes');
  },

  destroyed() {
    this.deselectedItemOnMenu('boxes');
  },
};
</script>
